(function () {
  const LOAD_MORE_PATTERN = /load more|show more|view more/i;

  const REVIEW_LIST_SELECTORS = [
    '[class*="alr-wh"][class*="review-list"]',
    '[class*="alr-wh"][class*="reviews-list"]',
    '[class*="alr-wh"][class*="review-box-list"]'
  ];

  const REVIEW_ITEM_SELECTORS = [
    '[class*="alr-wh"][class*="review-item"]',
    '[class*="alr-wh"][class*="review-card"]'
  ];

  const EXCLUDED_ANCESTOR_PATTERN = /summary|distribution|media|filter|search|header|toolbar|sort|question|qa/i;

  function collectRoots(node, roots = []) {
    if (!node) return roots;
    roots.push(node);
    node.querySelectorAll('*').forEach((el) => {
      if (el.shadowRoot) collectRoots(el.shadowRoot, roots);
    });
    return roots;
  }

  function queryAllDeep(container, selectors) {
    const matches = [];
    const seen = new Set();

    collectRoots(container).forEach((root) => {
      selectors.forEach((selector) => {
        root.querySelectorAll(selector).forEach((el) => {
          if (!seen.has(el)) {
            seen.add(el);
            matches.push(el);
          }
        });
      });
    });

    return matches;
  }

  function isExcludedList(list) {
    const classNames = `${list.className} ${list.parentElement?.className || ''}`;
    if (EXCLUDED_ANCESTOR_PATTERN.test(classNames)) return true;
    if (list.closest('[class*="summary"], [class*="distribution"], [class*="media-section"], [class*="search"]')) {
      return true;
    }

    // Star breakdown lists are short and nested inside summary blocks.
    if (list.children.length <= 5 && list.closest('[class*="summary"]')) return true;

    return false;
  }

  function getTopLevelReviewItems(items) {
    return items.filter((item) => !items.some((other) => other !== item && other.contains(item)));
  }

  function getReviewItems(widgetRoot) {
    const box = widgetRoot.querySelector('.alireviews-review-box') || widgetRoot;
    const lists = queryAllDeep(box, REVIEW_LIST_SELECTORS).filter((list) => !isExcludedList(list));

    let bestList = null;
    let bestCount = 0;

    lists.forEach((list) => {
      const childCount = list.children.length;
      if (childCount > bestCount) {
        bestCount = childCount;
        bestList = list;
      }
    });

    if (bestList && bestCount > 0) {
      return [...bestList.children].filter((child) => child.nodeType === 1);
    }

    return getTopLevelReviewItems(queryAllDeep(box, REVIEW_ITEM_SELECTORS));
  }

  function clearLimited(section) {
    section.querySelectorAll('.homepage-reviews__item--limited').forEach((item) => {
      item.classList.remove('homepage-reviews__item--limited');
    });
  }

  function applyReviewLimit(section) {
    if (section.classList.contains('homepage-reviews--expanded')) return;

    const maxVisible = parseInt(section.dataset.initialReviews, 10) || 10;
    const widgetRoot = section.querySelector('.homepage-reviews__widget') || section;
    const items = getReviewItems(widgetRoot);

    clearLimited(section);

    if (items.length <= maxVisible) return;

    items.forEach((item, index) => {
      item.classList.toggle('homepage-reviews__item--limited', index >= maxVisible);
    });
  }

  function bindLoadMore(section) {
    if (section.dataset.loadMoreBound === 'true') return;
    section.dataset.loadMoreBound = 'true';

    section.addEventListener('click', (event) => {
      const trigger = event.target.closest('button, a, [role="button"]');
      if (!trigger || !LOAD_MORE_PATTERN.test(trigger.textContent || '')) return;

      section.classList.add('homepage-reviews--expanded');
      clearLimited(section);
    });
  }

  function initSection(section) {
    bindLoadMore(section);

    const scheduleApply = () => {
      window.clearTimeout(section._homepageReviewsApplyTimer);
      section._homepageReviewsApplyTimer = window.setTimeout(() => {
        applyReviewLimit(section);
      }, 120);
    };

    scheduleApply();

    if (section._homepageReviewsObserver) return;

    section._homepageReviewsObserver = new MutationObserver(scheduleApply);

    const widgetRoot = section.querySelector('.homepage-reviews__widget') || section;
    section._homepageReviewsObserver.observe(widgetRoot, {
      childList: true,
      subtree: true
    });

    // Ali Reviews injects asynchronously; re-check after initial paint.
    window.setTimeout(scheduleApply, 800);
    window.setTimeout(scheduleApply, 2000);
  }

  function init() {
    document.querySelectorAll('.homepage-reviews[data-initial-reviews]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.homepage-reviews[data-initial-reviews]');
    if (section) initSection(section);
  });
})();
